export enum MeasurementPointIdStatuses {
  Complete = 'Complete',
  Pending = 'Pending',
  CompleteWithAlarm = 'CompleteWithAlarm',
  Skipped = 'Skipped',
}
